import { Component, ViewChildren, QueryList, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '../../../services/translate/translate.service';
import { ToasterService } from '../../../shared-components/custom-toaster/toaster.service';
import { CustomInputComponent } from '../../../shared-components/custom-input/custom-input.component';
import { CustomSelectComponent, SelectOption } from '../../../shared-components/custom-select/custom-select.component';
import { CustomCheckboxComponent } from '../../../shared-components/custom-checkbox/custom-checkbox.component';
import { CustomSwitchComponent } from '../../../shared-components/custom-switch/custom-switch.component';
import { CustomRadioComponent, RadioOption } from '../../../shared-components/custom-radio/custom-radio.component';
import { CustomDatePickerComponent } from '../../../shared-components/custom-date-picker/custom-date-picker.component';
import { FormValidationUtils, ComponentType } from '../../../utils/form-validation';
import { SmartFormBaseComponent } from '../../../utils/smart-form-base.component';

@Component({
	selector: 'app-form-components-showcase',
	templateUrl: './form-components-showcase.component.html',
	styleUrls: ['./form-components-showcase.component.scss'],
	standalone: false,
})
export class FormComponentsShowcaseComponent extends SmartFormBaseComponent implements AfterViewInit {
	@ViewChildren(CustomInputComponent) inputComponents!: QueryList<CustomInputComponent>;
	@ViewChildren(CustomSelectComponent) selectComponents!: QueryList<CustomSelectComponent>;
	@ViewChildren(CustomCheckboxComponent) checkboxComponents!: QueryList<CustomCheckboxComponent>;
	@ViewChildren(CustomSwitchComponent) switchComponents!: QueryList<CustomSwitchComponent>;
	@ViewChildren(CustomRadioComponent) radioComponents!: QueryList<CustomRadioComponent>;
	@ViewChildren(CustomDatePickerComponent) datePickerComponents!: QueryList<CustomDatePickerComponent>;

	constructor(
		private translateService: TranslateService,
		private toasterService: ToasterService,
		private cdr: ChangeDetectorRef
	) {
		super();
	}

	public isValidating: boolean = false;

	public selectOptions: SelectOption[] = [
		{ label: 'Option A', value: 'a' },
		{ label: 'Option B', value: 'b' },
		{ label: 'Option C', value: 'c' },
	];

	public radioOptions: RadioOption[] = [
		{ value: 'yes', displayValue: 'Yes' },
		{ value: 'no', displayValue: 'No' },
	];

	private readonly fieldConfigs = [
		{ name: 'input', type: ComponentType.INPUT },
		{ name: 'select', type: ComponentType.SELECT },
		{ name: 'checkbox', type: ComponentType.CHECKBOX },
		{ name: 'switch', type: ComponentType.SWITCH },
		{ name: 'radio', type: ComponentType.RADIO },
		{ name: 'datePicker', type: ComponentType.DATE_PICKER },

		{ name: 'inputReadonly', type: ComponentType.INPUT },
		{ name: 'selectReadonly', type: ComponentType.SELECT },
		{ name: 'checkboxReadonly', type: ComponentType.CHECKBOX },
		{ name: 'switchReadonly', type: ComponentType.SWITCH },
		{ name: 'radioReadonly', type: ComponentType.RADIO },
		{ name: 'datePickerReadonly', type: ComponentType.DATE_PICKER },
	];

	ngAfterViewInit(): void {
		this.initializeForm();

		setTimeout(() => {
			if (this.formManager) {
				this.fillForm();
				this.cdr.detectChanges();
			}
		}, 0);
	}

	initializeForm(): void {
		this.formManager = FormValidationUtils.createSmartFormManagerWithQueryList(
			this.fieldConfigs,
			this.translateService,
			this.inputComponents,
			this.selectComponents,
			this.checkboxComponents,
			this.switchComponents,
			this.radioComponents,
			this.datePickerComponents
		);
	}

	validateForm(): void {
		this.onSubmit();
		if (!this.isFormValid) return;

		this.isValidating = true;
		setTimeout(() => {
			this.isValidating = false;
			this.toasterService.showSuccess('Form submitted successfully!');
		}, 1500);
	}

	fillForm(): void {
		if (this.formManager) {
			this.formManager.setValues({
				input: 'Jane Smith',
				select: 'a',
				checkbox: true,
				switch: true,
				radio: 'yes',
				datePicker: ['2025-03-01T00:00:00.000Z'],

				inputReadonly: 'Jane Smith',
				selectReadonly: 'a',
				checkboxReadonly: true,
				switchReadonly: true,
				radioReadonly: 'yes',
				datePickerReadonly: ['2025-03-01T00:00:00.000Z'],
			});
			this.formManager.validateAll();
			this.isFormValid = this.formManager.isValid();
		}
	}
}
